module.exports = __webpack_public_path__ + "static/media/help.ecc3fc6b.riv";